import { render } from "./TableBF.vue?vue&type=template&id=0de7854d"
import script from "./TableBF.vue?vue&type=script&lang=js"
export * from "./TableBF.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__